export enum PdfGeneratedStorageType {
  cloudStorage = 'cloudStorage',
  localStorage = 'localStorage',
}
